export const rememberEntity = (param, id) => {
  const url = new URL(window.location.href)
  if (id) url.searchParams.set(param, id)
  else url.searchParams.delete(param)
  window.history.replaceState(null, "", url)
}
